import { EventsList } from '../../../components/Events/EventsList'

export const EventsSocialOrdersPage = () => <EventsList scope="social_orders" />
